import {all, call, fork, put, takeEvery} from 'bukku/shared/SagaService';
import actions from './actions';
import {post} from 'bukku/shared/ApiService';

// Read lists
export function* readStockBalancesRequest() {
    yield takeEvery(actions.STOCK_BALANCE_READ_REQUEST, function* ({ productId }, context) {
        try {
            // Prepare request data
            const requestData = {
                lists: ['stock_balances'],
                params: {stock_balances: {product_id: productId}},
            };

            // Request
            let responseData = {};
            if (requestData.lists.length) {
                const response = yield call(post, '/v2/lists', requestData, context);
                responseData = yield response.data;
            }

            yield put({
                type: actions.STOCK_BALANCE_READ_SUCCESS,
                responseData,
            });
        }
        catch (error) {
            yield put({
                type: actions.STOCK_BALANCE_READ_ERROR,
                error,
            });
        }
    });
}
export function* readStockBalancesSuccess() {
    yield takeEvery(actions.STOCK_BALANCE_READ_SUCCESS, () => {});
}
export function* readStockBalancesFailure() {
    yield takeEvery(actions.STOCK_BALANCE_READ_ERROR, () => {});
}

export default function* rootSaga() {
    yield all([
        fork(readStockBalancesRequest),
        fork(readStockBalancesSuccess),
        fork(readStockBalancesFailure),
    ]);
}
